module.exports = require('../dist/compat/math/maxBy.js').maxBy;
